<!-- //
边框图
@auth xuyd
@date 2024-05-01
//-->
<template>
  <dv-border-box-1 class="widget-view" :style="{}">
  </dv-border-box-1>
</template>

<script>
export default {
  name: 'WidgetBorderView',
  components: {},
  data() {
    return {
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
}

</script>
<style lang="less" scoped>
.widget-view {
  width: 100%;
  height: 100%;
}
</style>
